import { SVGProps } from "react";

export const ENSIndexerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M2 2H26V26H2V2Z" fill="#36D9FB" />
    <rect x="1" y="1" width="26" height="26" rx="3" fill="#36D9FB" stroke="black" strokeWidth="2" />
    <path d="M26.5 9.5H18.5V17.5H22.5V21.5" stroke="black" />
    <circle cx="5.5" cy="5.5" r="1" stroke="black" />
    <circle cx="6.5" cy="22.5" r="1" stroke="black" />
    <path d="M1.5 16.5H6.5V21.5" stroke="black" />
    <path d="M5.5 6V13.5H9.5V21H13V27" stroke="black" />
    <circle cx="17.5" cy="22.5" r="1" stroke="black" />
    <circle cx="14.5" cy="9.5" r="1" stroke="black" />
    <circle cx="22.5" cy="5.5" r="1" stroke="black" />
    <circle cx="22.5" cy="13.5" r="1" stroke="black" />
    <circle cx="22.5" cy="22.5" r="1" stroke="black" />
    <circle cx="14.5" cy="17.5" r="1" stroke="black" />
    <circle cx="9.5" cy="9.5" r="1" transform="rotate(90 9.5 9.5)" stroke="black" />
    <path d="M14.5 10.5V13.75V16.5" stroke="black" />
    <path d="M17.5 23V27.5" stroke="black" />
    <path d="M22.5 1V4.5" stroke="black" />
    <path d="M26 13.5H23.5" stroke="black" />
    <path d="M18.5 1.5L18.5 5.5L9.5 5.5L9.5 8.5" stroke="black" />
  </svg>
);
